import { render, staticRenderFns } from "./SelectedReadonly.vue?vue&type=template&id=e0bcaddc"
import script from "./SelectedReadonly.vue?vue&type=script&lang=js"
export * from "./SelectedReadonly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports